// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper{
    height: 100vh;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   gap: 1rem;
}

.login-form label {
    font-weight: 700;
}

 img {
    width: 100px;
    height: 100px;
    
   
}

.login-form .span-error {
    color: #F21C00;
}

.login-wrapper .login-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: auto;
    width: 420px;
    padding: 2rem;
    border-radius: 5px;
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.25);



}

.login-form #inputField {
  
    border:  1px solid #F21C00;
    padding: 8px;
    border-radius: 4px;

}

 .btn-login {
    margin-top: 1rem;
  
    background-color: #F21C00;
    color: white;
    padding: 8px;
    border-radius: 3px;
}

.login-form h2 {
    text-align: center;
}



/* section option */
.sectionAdmin-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 3rem;
    margin-top: 3rem;
}
.sectionAdmin-wrapper .sectionOptions {
    display: flex;
    text-align: center;
    gap: 2rem;

}


.sectionOptions .sectionUnique {
 
    padding: 2rem;
    border: 1px solid black;
    border-radius: 10px;
    width: 380px;
  
}

.sectionOptions .sectionUnique h1 {
    font-size: 25px;

}



.btn-section {
    margin-top: 1rem;
    border: none;
    background-color: #F21C00;
    color: white;
    padding: 8px;
   padding: 7px 32px;
    border-radius: 3px;

}

`, "",{"version":3,"sources":["webpack://./src/admin/styles/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;GACd,aAAa;GACb,uBAAuB;GACvB,mBAAmB;GACnB,sBAAsB;GACtB,SAAS;AACZ;;AAEA;IACI,gBAAgB;AACpB;;CAEC;IACG,YAAY;IACZ,aAAa;;;AAGjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,+CAA+C;;;;AAInD;;AAEA;;IAEI,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;;AAEtB;;CAEC;IACG,gBAAgB;;IAEhB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;;;AAIA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;;AAEb;;;AAGA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;IACI,eAAe;;AAEnB;;;;AAIA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;GACb,iBAAiB;IAChB,kBAAkB;;AAEtB","sourcesContent":[".login-wrapper{\r\n    height: 100vh;\r\n   display: flex;\r\n   justify-content: center;\r\n   align-items: center;\r\n   flex-direction: column;\r\n   gap: 1rem;\r\n}\r\n\r\n.login-form label {\r\n    font-weight: 700;\r\n}\r\n\r\n img {\r\n    width: 100px;\r\n    height: 100px;\r\n    \r\n   \r\n}\r\n\r\n.login-form .span-error {\r\n    color: #F21C00;\r\n}\r\n\r\n.login-wrapper .login-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    height: auto;\r\n    width: 420px;\r\n    padding: 2rem;\r\n    border-radius: 5px;\r\n    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.25);\r\n\r\n\r\n\r\n}\r\n\r\n.login-form #inputField {\r\n  \r\n    border:  1px solid #F21C00;\r\n    padding: 8px;\r\n    border-radius: 4px;\r\n\r\n}\r\n\r\n .btn-login {\r\n    margin-top: 1rem;\r\n  \r\n    background-color: #F21C00;\r\n    color: white;\r\n    padding: 8px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.login-form h2 {\r\n    text-align: center;\r\n}\r\n\r\n\r\n\r\n/* section option */\r\n.sectionAdmin-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 3rem;\r\n    margin-top: 3rem;\r\n}\r\n.sectionAdmin-wrapper .sectionOptions {\r\n    display: flex;\r\n    text-align: center;\r\n    gap: 2rem;\r\n\r\n}\r\n\r\n\r\n.sectionOptions .sectionUnique {\r\n \r\n    padding: 2rem;\r\n    border: 1px solid black;\r\n    border-radius: 10px;\r\n    width: 380px;\r\n  \r\n}\r\n\r\n.sectionOptions .sectionUnique h1 {\r\n    font-size: 25px;\r\n\r\n}\r\n\r\n\r\n\r\n.btn-section {\r\n    margin-top: 1rem;\r\n    border: none;\r\n    background-color: #F21C00;\r\n    color: white;\r\n    padding: 8px;\r\n   padding: 7px 32px;\r\n    border-radius: 3px;\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
